module.exports = __webpack_public_path__ + "img/herohire-iphone-01.a5c34f5c.png";